angular.module('zc.zenclerkS')
  .controller('ZcsSiteStatsShowController', ZcsSiteStatsShowController);

ZcsSiteStatsShowController.$inject = ['$stateParams', '$translate', 'currencies', 'project', 'stats'];
function ZcsSiteStatsShowController($stateParams, $translate, currencies, project, stats) {
  const vm = this;

  // variables
  vm.project = project;
  vm.stats = stats;
  vm.summarize_at = moment(vm.stats && vm.stats.summarize_at).format('YYYY-MM-DD');
  vm.month = $stateParams.month;
  vm.filterText = '';
  vm.histories = [];
  vm.sortFields = [
    { value: 'price', label: $translate.instant('sites.stats.siteStatsShow.tanka')},
    { value: 'monthly.pv', label: $translate.instant('sites.stats.siteStatsShow.akusesu_kazu')},
    { value: 'monthly.conversion_count', label: $translate.instant('sites.stats.siteStatsShow.kaisuu')},
    { value: 'monthly.conversion_amount', label: $translate.instant('sites.stats.siteStatsShow.hanbai_suuryou')},
    { value: 'monthly.conversion_price', label: $translate.instant('sites.stats.siteStatsShow.kingaku')},
    { value: 'monthly.conversion_ratio', label: $translate.instant('sites.stats.siteStatsShow.ritsu')},
    { value: 'monthly.sales_ratio', label: $translate.instant('sites.stats.siteStatsShow.uriage_kouseihi')},
  ];

  vm.sortItems = sortItems;
  vm.currency = currencies[vm.project.currency];

  activate();

  function activate() {
    vm.sortField = 'monthly.conversion_price';
    vm.sortItems();
  }

  function sortItems() {
    vm.sortedItems = _.chain(vm.stats && vm.stats.items)
      .filter(d => d.name.indexOf(vm.filterText) >= 0)
      .sortBy(d => -(_.get(d, vm.sortField)))
      .value();
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/stats/site_stats_show.controller.js